import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { copyNeta, deleteNeta, netaUsers } from "../../../store/API/MemberApis";
import Table from "../../../components/common/TableComponent";
import Pagination from "../../../components/common/Pagination";
import {
  getDistrictList,
  getDivisionList,
  getSeatList,
  getUpazilaList,
} from "../../../store/apis";
import { DistrictType, SeatType, UpazilaType } from "../../../models";
import { getPartyList } from "../../../store/API/CommonApis";
import { toast, ToastContainer } from "react-toastify";

const NetaUserList = () => {
  const { netaList } = useAppSelector((state) => state.member);
  const { division, district, upazila, seat, partyList } = useAppSelector(
    (state) => state.common
  );

  const [searchValue, setSearchValue] = useState("");
  const [districtOprion, setDistrictOprion] = useState<DistrictType[]>([]);
  const [upazilaOption, setUpazilaOption] = useState<UpazilaType[]>([]);
  const [seatOption, setSeatOption] = useState<SeatType[]>([]);
  const [divisionValue, setDivisionValue] = useState("");
  const [districtValue, setDistricValue] = useState("");
  const [upazilaData, setUpazilaData] = useState("");
  const [seatData, setSeatData] = useState("");
  const [partyListValue, setPartyListValue] = useState("");
  const [selectedPage, setSelectedPage] = useState(1);

  const [remountComponent, setRemountComponent] = useState(0);
  const [status, setStatus] = useState("approved");

  const dispatch = useAppDispatch();
  const limit = 10;
  useEffect(() => {
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
      })
    );
    dispatch(getDivisionList());
    dispatch(getDistrictList());
    dispatch(getUpazilaList());
    dispatch(getSeatList());

    dispatch(getPartyList());
  }, [dispatch]);

  useEffect(() => {
    setDistrictOprion(district);
  }, [district]);

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Seat", accessor: (item: any) => item.seat?.name || "N/A" },
    // { header: "Email", accessor: "email" },
    { header: "Type", accessor: "member_type" },
    // { header: "Neta", accessor: (item: any) => getAllMemberNames(item.member) },
  ];
  const handlePageClick = (data: any) => {
    dispatch(
      netaUsers({
        page: data.selected + 1,
        page_size: limit,
        search: searchValue,
        political_party: partyListValue,
        district: districtValue,
        division: divisionValue,
        status: status,
      })
    );
    setSelectedPage(data.selected + 1);
  };

  const handleSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      dispatch(
        netaUsers({
          page: 1,
          page_size: limit,
          search: searchValue,
          status: status,
        })
      );
    }
    setRemountComponent(Math.random());
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatus(e.target.value);
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
        status: e.target.value,
      })
    );
  };
  const handleDivisionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const filteredDistricts = district?.filter(
      (item: DistrictType) => item.division.id === parseInt(e.target.value)
    );
    setDistrictOprion(filteredDistricts);
    setDivisionValue(e.target.value);
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
        division: e.target.value,
        political_party: partyListValue,
        status: status,
      })
    );
  };
  const handleDistrictChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDistricValue(e.target.value);
    const filteredUpazila = e.target.value
      ? upazila.filter(
          (item: UpazilaType) => String(item.district.id) === e.target.value
        )
      : upazila;

    setUpazilaOption(filteredUpazila || []);
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
        district: e.target.value,
        political_party: partyListValue,
        status: status,
      })
    );
  };

  const handlePartyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPartyListValue(e.target.value);
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
        district: districtValue,
        division: divisionValue,
        political_party: e.target.value,
        status: status,
      })
    );
  };
  const handleUpazilaSelectChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setUpazilaData(e.target.value);
    setSeatData("");
    const filteredSeat = e.target.value
      ? seat.filter((item: SeatType) =>
          item.upazila.some(
            (upazilaId: number) => upazilaId === parseInt(e.target.value)
          )
        )
      : seat;
    setSeatOption(filteredSeat);
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
        upazila: e.target.value,
        political_party: partyListValue,
        status: status,
      })
    );
  };

  const handleSeatSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSeatData(e.target.value);
    dispatch(
      netaUsers({
        page: 1,
        page_size: limit,
        seat: e.target.value,
        political_party: partyListValue,
        status: status,
      })
    );
  };
  const handleNetaEdit = (item: any): void => {
    const url = `/admin/neta/edit/${item.id}`;
    window.open(url, "_blank"); // Opens the URL in a new tab
  };

  const handleDelete = (item: any): void => {
    // Implement delete functionality here
    try {
      console.log("Delete item with id:", item);
      dispatch(
        deleteNeta({
          id: item,
          page: selectedPage,
          page_size: limit,
          district: districtValue,
          divisione: divisionValue,
          upazila: upazilaData,
        })
      );
      toast.success("Item deleted successfully.");
      return;
    } catch (error) {
      console.log(error);
      toast.error("Failed to delete the item.");
      return;
    }
  };

  const handleViewDetails = (item: any): void => {
    const url = `/admin/user/neta/details/${item}`;
    window.open(url, "_blank"); // Opens the URL in a new tab
    return;
  };

  const handleCopyMember = (item: any): void => {
    console.log("Copy item with id:", item);
    try {
      dispatch(
        copyNeta({
          id: item.id,
          page: selectedPage,
          page_size: limit,
          district: districtValue,
          divisione: divisionValue,
          upazila: upazilaData,
        })
      );
      toast.success("Item copied successfully.");
      return;
    } catch (error) {
      console.log(error);
      toast.error("Failed to copy the item.");
      return;
    }
  };

  return (
    <div className="flex flex-col gap-4 px-4 pt-6 text-start justify-center">
      <ToastContainer />
      <div className="m-3">
        <p className="text-center">Neta List</p>
        <div className="flex flex-wrap items-center gap-2">
          {/* search bar */}
          <div className="relative w-full md:w-1/3 my-2">
            <div className="flex absolute inset-y-0 left-0 items-center pl-3">
              <svg
                className="w-5 h-5 text-gray-500 dark:text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={handleSearch}
              id="simple-search"
              className="border border-gray-300 text-gray-900 rounded-lg focus:ring-gray-900 focus:border-gray-900 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
              placeholder="Search here.."
            />
          </div>

          {/* status select */}
          <select
            value={status}
            onChange={handleStatusChange}
            className="form-select w-full md:w-auto text-gray-700 bg-white border border-solid border-gray-300 rounded focus:ring-gray-900 focus:border-gray-900 h-11"
          >
            <option value="">All</option>
            <option value="REGULAR">Regular</option>
            <option value="SHADOW">Shadow</option>
            <option value="PROSPECTIVE">Prospective</option>
          </select>

          {/* division select */}
          <select
            value={divisionValue}
            onChange={handleDivisionChange}
            className="form-select w-full md:w-auto text-gray-700 bg-white border border-solid border-gray-300 rounded focus:ring-gray-900 focus:border-gray-900 h-11"
          >
            <option value="">Select Division</option>
            {division?.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item?.name}
              </option>
            ))}
          </select>

          {/* district select */}
          <select
            value={districtValue}
            onChange={handleDistrictChange}
            className="form-select w-full md:w-auto text-gray-700 bg-white border border-solid border-gray-300 rounded focus:ring-gray-900 focus:border-gray-900 h-11"
          >
            <option value="">Select District</option>
            {districtOprion?.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item?.name}
              </option>
            ))}
          </select>

          {/* upazila select */}
          <select
            value={upazilaData}
            onChange={handleUpazilaSelectChange}
            className="form-select w-full md:w-auto text-gray-700 bg-white border border-solid border-gray-300 rounded focus:ring-gray-900 focus:border-gray-900 h-11"
          >
            <option value="">Select Upazila</option>
            {upazilaOption?.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item?.name}
              </option>
            ))}
          </select>

          {/* seat select */}
          <select
            value={seatData}
            onChange={handleSeatSelectChange}
            className="form-select w-full md:w-auto text-gray-700 bg-white border border-solid border-gray-300 rounded focus:ring-gray-900 focus:border-gray-900 h-11"
          >
            <option value="">Select Seat</option>
            {seatOption?.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item?.name}
              </option>
            ))}
          </select>

          {/* party select */}
          <select
            value={partyListValue}
            onChange={handlePartyChange}
            className="form-select w-full md:w-auto text-gray-700 bg-white border border-solid border-gray-300 rounded focus:ring-gray-900 focus:border-gray-900 h-11"
          >
            <option value="">Select Political Party</option>
            {partyList?.map((item: any) => (
              <option key={item.id} value={item.id}>
                {item?.name}
              </option>
            ))}
          </select>
        </div>

        <Table
          columns={columns}
          data={netaList?.results || []}
          onEdit={handleNetaEdit}
          onDelete={handleDelete}
          onView={handleViewDetails}
          onCopy={handleCopyMember}
        />
        <div className="mt-8 flex justify-end" key={remountComponent}>
          <Pagination
            pageCount={netaList?.count && Math.ceil(netaList?.count / limit)}
            handlePageClick={handlePageClick}
            pageRange={2}
          />
        </div>
      </div>
    </div>
  );
};

export default NetaUserList;
